module.exports = __webpack_public_path__ + "static/media/4.0797a9d6.JPG";